var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ExpiringStorage, SELECTORS } from '@oneaudi/stck-store';
import { areFilterArraysEqualish } from '../utils/utils';
import { useServicesContext } from '../../../context';
import { useScsUrlParts } from '../../../hooks';
import { trackRemoveAllFilters } from '../tracking';
import { useApplyFilters, useClearAllDealerFilters, useClearAllFilters, } from '../FilterContextHooks';
import { findCategoryInFilterConfig } from '../utils/filterHelper';
import { FilterContext } from '../FilterContext';
import { useI18n } from '@oneaudi/i18n-context';
import { useMandatoryAreaSearchContext } from '../hooks/MandatoryAreaSearchContext';
import { setLocationFilterToDefaultState } from '../utils/locationFilterHelpers';
import styled from 'styled-components';
import { TextLink, Tag, TagGroup, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, SYS_SPACE_FIXED_500, SYS_SPACE_RELATIVE_XS, } from '@oneaudi/unified-web-common';
import { DynamicComponent, dynamicStyling, dynamicStylingHelper, DynamicThemeProviderWrapper, resetNumVehiclesOnPLP, } from '../../utils';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_600, SYS_SPACE_RELATIVE_LG, SYS_SPACE_RELATIVE_MD, SYS_SPACE_RELATIVE_SM, } from '@oneaudi/unified-web-alpha-common';
import { DangerousElement } from '../../../components';
export const ChipsList = ({ configuredFilters, isPlpQuickFilters }) => {
    const clearAllFilters = useClearAllFilters();
    const clearAllDealerFilters = useClearAllDealerFilters();
    const applyFilters = useApplyFilters();
    const context = React.useContext(FilterContext);
    const servicesContext = useServicesContext();
    const localeService = servicesContext.getAdditionalService('gfa:locale-service');
    const marketLanguage = localeService.language;
    const contentService = servicesContext.getAdditionalService('audi-content-service');
    let { mileageUnit } = contentService.getContent().fields;
    const mileageUn = mileageUnit || 'km';
    const i18nService = servicesContext.getAdditionalService('dbad:audi-i18n-service');
    const trackingService = servicesContext.getAdditionalService('audi-tracking-service');
    const { isUsedCarMkt, marketPath } = useScsUrlParts();
    const { enableMandatoryAreaSearch, requireMandatoryAreaSearchLocation } = useMandatoryAreaSearchContext();
    const localStorageLocationSearchInputKey = enableMandatoryAreaSearch
        ? `VTP_${marketPath}_mandatoryLocationSearch--input`
        : `VTP_${marketPath}_locationSearch--input`;
    const totalResults = useSelector((state) => SELECTORS.VEHICLES.getTotalCountState(state));
    const allSelectedFilters = useSelector((state) => SELECTORS.FILTERS.getSelectedFiltersMap(state));
    const allI18n = (i18nService === null || i18nService === void 0 ? void 0 : i18nService.getMessages()[marketLanguage])
        ? i18nService === null || i18nService === void 0 ? void 0 : i18nService.getMessages()[marketLanguage]
        : i18nService === null || i18nService === void 0 ? void 0 : i18nService.getMessages().default;
    const getI18n = ({ id, defaultMessage = '', }) => {
        return allI18n[id] || defaultMessage || undefined;
    };
    const deleteFiltersLabel = useI18n({
        id: `nemo.ui.sc.filter-options.reset.label`,
        defaultMessage: 'Reset Filters',
    });
    const showMoreFilterLabel = useI18n({
        id: `nemo.ui.sc.filter-options.more.label`,
        defaultMessage: 'more Filter',
    });
    const showFewerFilterLabel = useI18n({
        id: `nemo.ui.sc.filter-options.less.label`,
        defaultMessage: 'Show less',
    });
    const chosenFiltersLabel = useI18n({
        id: `nemo.sc.filter.chosenFilters`,
        defaultMessage: 'Selected Filters',
    });
    const dealerLabelPrefix = useI18n({
        id: `nemo.ui.sc.details.dealer-label`,
        defaultMessage: '',
    });
    const locationChipLabelPrefix = useI18n({
        id: `nemo.sc.filter.locationChipLabelPrefix`,
        defaultMessage: 'Location',
    });
    const filterOptionsFromStore = useSelector((state) => {
        if (!SELECTORS.UI.getLoadingState(state)) {
            return SELECTORS.FILTERS.getFilterOptionsState(state);
        }
        return;
    });
    const getAllFilterDTOFromRedux = useSelector((state) => SELECTORS.FILTERS.getFilterDTOsMap(state));
    const persistedFilters = useSelector((state) => SELECTORS.FILTERS.getPersistedFiltersMaps(state));
    const persistedPresets = useSelector((state) => SELECTORS.FILTERS.getPersistedPresetsMap(state));
    const [allChips, setAllChips] = useState([]);
    const [showAllChips, setShowAllChips] = useState(false);
    const maxNumberOfChipsMobile = 4;
    const maxNumberOfChipsDesktop = 8;
    let maxNumberOfChipsToDisplay = window.innerWidth < 768 ? maxNumberOfChipsMobile : maxNumberOfChipsDesktop;
    if (isPlpQuickFilters) {
        maxNumberOfChipsToDisplay =
            window.innerWidth < 768 ? maxNumberOfChipsMobile : window.innerWidth < 1024 ? 8 : 4;
    }
    const numberOfAdditionalChips = allChips.length - maxNumberOfChipsToDisplay;
    const buildLocationFilterChip = (filter, filterGroup, filterDTO) => {
        var _a, _b, _c;
        const city = ((_a = filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.values) === null || _a === void 0 ? void 0 : _a[4]) || filter.text || (inputDataFromLocalStorage === null || inputDataFromLocalStorage === void 0 ? void 0 : inputDataFromLocalStorage.inputName) || '';
        const radius = ((_b = filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.values) === null || _b === void 0 ? void 0 : _b[2]) || '';
        const unit = ((_c = filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.values) === null || _c === void 0 ? void 0 : _c[3]) || '';
        if (!city) {
            return null;
        }
        const locationDetails = radius && unit ? `${city}, ${radius}${unit}` : city;
        return {
            id: (filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.id) || filter.id,
            filterOptionGroupName: filterGroup.group,
            filterOptionGroupText: filterGroup.text,
            group: (filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.group) || filterGroup.group,
            label: `${locationChipLabelPrefix}: ${locationDetails}`,
            remove: [(filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.id) || filter.id],
        };
    };
    const buildPersistedLocationFilterChip = () => {
        const persistedGeoFilter = (persistedFilters === null || persistedFilters === void 0 ? void 0 : persistedFilters.get('geo')) || (persistedPresets === null || persistedPresets === void 0 ? void 0 : persistedPresets.get('geo'));
        if (!(persistedGeoFilter === null || persistedGeoFilter === void 0 ? void 0 : persistedGeoFilter.active) && !(persistedGeoFilter === null || persistedGeoFilter === void 0 ? void 0 : persistedGeoFilter.preset)) {
            return null;
        }
        return buildLocationFilterChip({ id: 'geo' }, { group: 'dealer', text: undefined }, persistedGeoFilter);
    };
    const buildPendingLocationFilterChip = () => {
        if (!context.searchedCoords) {
            return null;
        }
        const city = inputDataFromLocalStorage === null || inputDataFromLocalStorage === void 0 ? void 0 : inputDataFromLocalStorage.inputName;
        if (!city) {
            return null;
        }
        return buildLocationFilterChip({ id: 'geo', text: city }, { group: 'dealer', text: undefined }, {
            id: 'geo',
            active: true,
            type: 'location-filter',
            values: [
                String(context.searchedCoords.latitude),
                String(context.searchedCoords.longitude),
                context.radius || '',
                mileageUn,
                city,
            ],
            group: 'dealer',
        });
    };
    const hasPlaceholderLabel = (cleanId) => {
        const genericPlaceholderLabel = getI18n({
            id: `nemo.sc.filtergroups.${cleanId}.rangepattern`,
        });
        const mileageUniPlaceholderLabel = getI18n({
            id: `nemo.sc.filtergroups.${cleanId}.${mileageUn}.rangepattern`,
        });
        if (genericPlaceholderLabel === null || genericPlaceholderLabel === void 0 ? void 0 : genericPlaceholderLabel.includes('{{=it.minmax1}}')) {
            return genericPlaceholderLabel;
        }
        if (mileageUniPlaceholderLabel === null || mileageUniPlaceholderLabel === void 0 ? void 0 : mileageUniPlaceholderLabel.includes('{{=it.minmax1}}')) {
            return mileageUniPlaceholderLabel;
        }
        return false;
    };
    const getAllSelectedChipsLabel = (id) => {
        var _a;
        const allSelectedPairsString = getI18n({
            id: `nemo.sc.filteroptions.allselected-pairs`,
            defaultMessage: 'exterior colour:All exterior colours|interior-colour-seats:All seat colours|material:All materials|etron:e-tron|etrongt:e-tron GT|a1:A1|a3:A3|a4:A4|a5:A5|a6:A6|a7:A7|a8:A8|q2:Q2|q3:Q3|q4:Q4 e-tron|q5:Q5|q7:Q7|q8:Q8|q8etron:Q8 e-tron|tt:TT|r8:R8|etron:e-tron|etrongt:e-tron GT',
        });
        const allSelectedPairs = {};
        for (const element of allSelectedPairsString.split('|')) {
            const pair = element.split(':');
            allSelectedPairs[pair[0]] = (_a = pair[1]) === null || _a === void 0 ? void 0 : _a.trim();
        }
        return allSelectedPairs[id] || undefined;
    };
    const makeMinMaxValueLabelPart = (filterDTO, cleanId) => {
        const { values, display } = filterDTO;
        const minValue = values === null || values === void 0 ? void 0 : values[0];
        const maxValue = values === null || values === void 0 ? void 0 : values[1];
        const minValueDisplay = (display === null || display === void 0 ? void 0 : display[0]) || minValue || '';
        const maxValueDisplay = (display === null || display === void 0 ? void 0 : display[1]) || maxValue || '';
        const rangeMinLabel = getI18n({
            id: `nemo.sc.filtergroups.${cleanId}.rangeMinLabel`,
            defaultMessage: 'from',
        });
        const rangeMaxLabel = getI18n({
            id: `nemo.sc.filtergroups.${cleanId}.rangeMaxLabel`,
            defaultMessage: 'to',
        });
        let valueLabelPart;
        if (minValue && !maxValue) {
            valueLabelPart = `${rangeMinLabel} ${minValueDisplay}`;
            if (hasPlaceholderLabel(cleanId)) {
                valueLabelPart = hasPlaceholderLabel(cleanId);
                valueLabelPart = `${rangeMinLabel} ${valueLabelPart
                    .replace('{{=it.minmax1}}', minValueDisplay)
                    .replace('{{=it.minmax2}}', (display === null || display === void 0 ? void 0 : display[2]) || '')}`;
            }
        }
        else {
            valueLabelPart = `${rangeMaxLabel} ${maxValueDisplay}`;
            if (hasPlaceholderLabel(cleanId)) {
                valueLabelPart = hasPlaceholderLabel(cleanId);
                valueLabelPart = `${rangeMaxLabel} ${valueLabelPart
                    .replace('{{=it.minmax1}}', maxValueDisplay)
                    .replace('{{=it.minmax2}}', (display === null || display === void 0 ? void 0 : display[3]) || '')}`;
            }
        }
        return valueLabelPart;
    };
    const getRangeValueLabel = (filterChipDTO) => {
        if (!filterChipDTO) {
            throw new Error('Missing param filterDTO in getRangeValueLabel!');
        }
        const cleanId = filterChipDTO.id.split('.all')[0].split(':min')[0].split(':max')[0];
        const labelValuePart = makeMinMaxValueLabelPart(filterChipDTO, cleanId);
        const specificI18nLabel = getI18n({
            id: `nemo.sc.filtergroups.${cleanId}`,
        });
        const labelFilternamePart = specificI18nLabel || filterChipDTO.id;
        return `${labelFilternamePart} ${labelValuePart}`;
    };
    const removeDuplicatedChips = (filterChipsDTOArray) => {
        const uniqueFilterChipsArray = [];
        const uniqueIdsArray = [];
        filterChipsDTOArray.forEach((filter) => {
            const uniqueId = filter.id === 'carlinegroups' ? filter.id + filter.label : filter.id;
            if (uniqueIdsArray.indexOf(uniqueId) === -1) {
                uniqueFilterChipsArray.push(filter);
                uniqueIdsArray.push(uniqueId);
            }
        });
        return uniqueFilterChipsArray;
    };
    const getAllSelectedCarlineGroupsChipsLabel = (groupId) => {
        return getAllSelectedChipsLabel(groupId) || groupId;
    };
    const generateFilterChipItemForEachFilterGroup = (filterGroup, groupId) => {
        const filterChipDTOsFromGroup = [];
        const selectedFiltersArray = filterGroup.selectedFilter || [];
        const hasAllSelectedChipsLabel = filterGroup.group === 'carlinegroups'
            ? getAllSelectedCarlineGroupsChipsLabel(groupId)
            : getAllSelectedChipsLabel(filterGroup.group);
        if (filterGroup.allSelected && hasAllSelectedChipsLabel) {
            let idsToRemove = [];
            selectedFiltersArray.forEach((filter) => {
                if (filterGroup.group === 'carlinegroups') {
                    idsToRemove = filter.remove;
                }
                else {
                    idsToRemove = [...idsToRemove, filter.remove[0]];
                }
            });
            const allSelectedFilterChip = {
                id: filterGroup.group,
                filterOptionGroupName: filterGroup.group,
                filterOptionGroupText: filterGroup.text,
                group: filterGroup.group,
                label: hasAllSelectedChipsLabel,
                remove: idsToRemove,
                allSelected: true,
            };
            filterChipDTOsFromGroup.push(allSelectedFilterChip);
        }
        else {
            selectedFiltersArray.forEach((filter) => {
                var _a, _b;
                const filterDTO = getAllFilterDTOFromRedux.get(filter.id);
                const isGeoLocationFilter = filter.id === 'geo';
                const filterLabel = filter.text || filter.id || '';
                if ((!filterDTO && !isGeoLocationFilter) || filterGroup.group === 'bodytypes') {
                    return;
                }
                switch ((filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.type) || (isGeoLocationFilter ? 'location-filter' : undefined)) {
                    case 'range-filter':
                        const rangeFilterChip = {
                            id: filterDTO.id,
                            filterOptionGroupName: filterGroup.group,
                            filterOptionGroupText: filterGroup.text,
                            group: filterDTO.group,
                            display: filter.display || undefined,
                            remove: [filterDTO.id],
                            values: filterDTO.values,
                            label: '',
                        };
                        const newRangeLabel = getRangeValueLabel(rangeFilterChip);
                        rangeFilterChip.label = newRangeLabel;
                        filterChipDTOsFromGroup.push(rangeFilterChip);
                        break;
                    case 'minmax-range-filter':
                        const minRangeFilterChip = {
                            id: `${filterDTO.id}:min`,
                            filterOptionGroupName: filterGroup.group,
                            filterOptionGroupText: filterGroup.text,
                            display: filter.display || undefined,
                            active: filterDTO.active,
                            preset: filterDTO.preset,
                            values: [(_a = filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.values) === null || _a === void 0 ? void 0 : _a[0], ''],
                            removeArr: [filterDTO.id],
                            group: filterDTO.group,
                            label: '',
                        };
                        minRangeFilterChip.label = getRangeValueLabel(minRangeFilterChip);
                        const maxRangeFilterChip = {
                            id: `${filterDTO.id}:max`,
                            filterOptionGroupName: filterGroup.group,
                            filterOptionGroupText: filterGroup.text,
                            display: filter.display || undefined,
                            active: filterDTO.active,
                            preset: filterDTO.preset,
                            values: ['', (_b = filterDTO === null || filterDTO === void 0 ? void 0 : filterDTO.values) === null || _b === void 0 ? void 0 : _b[1]],
                            removeArr: [filterDTO.id],
                            group: filterDTO.group,
                            label: '',
                        };
                        maxRangeFilterChip.label = getRangeValueLabel(maxRangeFilterChip);
                        filterChipDTOsFromGroup.push(minRangeFilterChip, maxRangeFilterChip);
                        break;
                    case 'location-filter':
                        const locationFilterChip = buildLocationFilterChip(filter, filterGroup, filterDTO);
                        if (locationFilterChip) {
                            filterChipDTOsFromGroup.push(locationFilterChip);
                        }
                        break;
                    case 'basic-filter':
                    default:
                        let label = filterLabel;
                        if (filterGroup.text && !filter.uniqueText) {
                            label = `${filterGroup.text}: ${filterLabel}`;
                        }
                        if (filterGroup.group === 'dealer') {
                            label = dealerLabelPrefix
                                ? `${dealerLabelPrefix} ${label}`
                                : `${dealerLabelPrefix}${label}`;
                        }
                        const basicFilterChip = {
                            id: filterDTO.id,
                            filterOptionGroupName: filterGroup.group,
                            filterOptionGroupText: filterGroup.text,
                            group: filterDTO.group,
                            label,
                            remove: [filterDTO.id],
                        };
                        filterChipDTOsFromGroup.push(basicFilterChip);
                        break;
                }
            });
        }
        return filterChipDTOsFromGroup;
    };
    const isMinMaxRangePseudoId = (chipFilterId) => {
        return !!(chipFilterId.split(':').length === 2);
    };
    const convertFilterOptionsFromStoreToChipsItems = () => {
        let filterChipsDTOArray = [];
        Object.entries(filterOptionsFromStore).forEach(([groupId, group]) => {
            const itemsArray = generateFilterChipItemForEachFilterGroup(group, groupId);
            filterChipsDTOArray = [...filterChipsDTOArray, ...itemsArray];
        });
        const locationChip = buildPersistedLocationFilterChip() || buildPendingLocationFilterChip();
        if (locationChip) {
            filterChipsDTOArray.push(locationChip);
        }
        const uniqueFilterOptionsArray = removeDuplicatedChips(filterChipsDTOArray);
        return uniqueFilterOptionsArray;
    };
    const handleChips = () => {
        const newChips = convertFilterOptionsFromStoreToChipsItems();
        if (newChips && !areFilterArraysEqualish(allChips, newChips)) {
            setAllChips(newChips);
        }
    };
    const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
    const inputDataFromLocalStorage = localStorage.readEntry();
    useEffect(() => {
        if (filterOptionsFromStore) {
            handleChips();
        }
    }, [
        filterOptionsFromStore,
        inputDataFromLocalStorage === null || inputDataFromLocalStorage === void 0 ? void 0 : inputDataFromLocalStorage.inputName,
        persistedFilters,
        persistedPresets,
    ]);
    const clearLocationFilter = () => {
        setLocationFilterToDefaultState(servicesContext.getConfiguration(), servicesContext.getEnvironmentConfig(), clearAllDealerFilters, context, { current: { value: '' } }, enableMandatoryAreaSearch, requireMandatoryAreaSearchLocation);
    };
    const handleRemove = (chip) => {
        var _a, _b;
        const componentName = isPlpQuickFilters ? 'vtp quick filter' : 'vtp filter';
        const trackingEventName = (chip === null || chip === void 0 ? void 0 : chip.filterOptionGroupName) === 'ranges' && (chip === null || chip === void 0 ? void 0 : chip.display[0]) !== '' && (chip === null || chip === void 0 ? void 0 : chip.display[1]) !== ''
            ? `${componentName} - change filter`
            : `${componentName} - remove filter`;
        const trackingLabel = chip === null || chip === void 0 ? void 0 : chip.label;
        const filterCategory = (_b = (_a = configuredFilters === null || configuredFilters === void 0 ? void 0 : configuredFilters.filter((configuredFilter) => {
            if (chip.group !== 'carlinegroups') {
                return (findCategoryInFilterConfig(configuredFilter, chip.id) ||
                    findCategoryInFilterConfig(configuredFilter, chip.group) ||
                    findCategoryInFilterConfig(configuredFilter, chip.filterOptionGroupName));
            }
            return findCategoryInFilterConfig(configuredFilter, 'carline');
        })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.filterCategory;
        let currentFilterForTracking;
        if (chip.allSelected) {
            const filtersToRemove = [];
            chip.remove.forEach((filterId) => {
                const individualFilterToRemove = {
                    id: filterId,
                    active: false,
                };
                filtersToRemove.push(individualFilterToRemove);
            });
            currentFilterForTracking = { id: chip.label.toLowerCase(), values: chip.values || [] };
            const trackingData = {
                trackingEventName,
                trackingLabel,
                trackingValue: filterCategory,
                changedFilter: [currentFilterForTracking],
            };
            applyFilters(filtersToRemove, trackingData);
        }
        else {
            if ((chip === null || chip === void 0 ? void 0 : chip.id) === 'geo') {
                clearLocationFilter();
                return;
            }
            const chipToRemove = {
                id: chip.id,
                active: false,
            };
            if (isMinMaxRangePseudoId(chip.id)) {
                const cleanId = chip.id.split(':')[0];
                const minOrMax = chip.id.split(':')[1];
                chipToRemove.id = cleanId;
                const prevFilter = getAllFilterDTOFromRedux.get(cleanId);
                if (minOrMax === 'min') {
                    chipToRemove.active = true;
                    chipToRemove.values = ['', prevFilter === null || prevFilter === void 0 ? void 0 : prevFilter.values[1]];
                }
                if (minOrMax === 'max') {
                    chipToRemove.active = true;
                    chipToRemove.values = [prevFilter === null || prevFilter === void 0 ? void 0 : prevFilter.values[0], ''];
                }
            }
            currentFilterForTracking = { id: chip.id, values: chip.values || [] };
            const trackingData = {
                trackingEventName,
                trackingLabel,
                trackingValue: filterCategory,
                changedFilter: [currentFilterForTracking],
            };
            applyFilters(chipToRemove, trackingData);
        }
    };
    const handleShowMoreChips = () => {
        setShowAllChips(true);
    };
    const handleShowFewerChips = () => {
        setShowAllChips(false);
    };
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        const trackingRelatedFilters = [];
        [...allSelectedFilters.values()].forEach((filter) => {
            const relatedFilter = { id: filter.id, values: filter.values || [] };
            trackingRelatedFilters.push(relatedFilter);
        });
        resetNumVehiclesOnPLP();
        trackRemoveAllFilters(trackingService, isPlpQuickFilters ? 'vtp quick filter - remove all filter' : 'vtp filter - remove all filter', 'text link', deleteFiltersLabel, trackingRelatedFilters, totalResults, isUsedCarMkt);
        yield clearAllFilters();
        clearLocationFilter();
    });
    if (allChips.length === 0) {
        return null;
    }
    const visibleChips = allChips.filter((_, index) => index < maxNumberOfChipsToDisplay || showAllChips);
    const renderedChips = visibleChips.map((chip, index) => (React.createElement(StyledTag, { "aria-label": chip.label, label: React.createElement(DangerousElement, { html: chip.label }), onClick: () => handleRemove(chip), key: chip.id + index, size: isPlpQuickFilters ? 'md' : dynamicStylingHelper('md', 'sm'), variant: "removable", isPlpQuickFilters: isPlpQuickFilters, isLastTag: index === allChips.length - 1 })));
    return (React.createElement(StyledTagGroup, { "aria-label": chosenFiltersLabel, size: "sm", isPlpQuickFilters: isPlpQuickFilters },
        isPlpQuickFilters ? (React.createElement(DynamicComponent, { legacy: renderedChips, alpha: React.createElement(ChipsWrapper, null, renderedChips) })) : (renderedChips),
        React.createElement(FilterChipsFooter, { isPlpQuickFilters: isPlpQuickFilters },
            numberOfAdditionalChips > 0 && !showAllChips && (React.createElement("span", { role: "listitem" },
                React.createElement(DynamicThemeProviderWrapper, null,
                    React.createElement(StyledTextLink, { icon: "add", iconPosition: "leading", size: "sm", variant: "standalone", onClick: handleShowMoreChips },
                        numberOfAdditionalChips,
                        " ",
                        showMoreFilterLabel)))),
            numberOfAdditionalChips > 0 && showAllChips && (React.createElement("span", { role: "listitem" },
                React.createElement(DynamicThemeProviderWrapper, null,
                    React.createElement(StyledTextLink, { icon: "remove", iconPosition: "leading", size: "sm", variant: "standalone", onClick: handleShowFewerChips }, showFewerFilterLabel)))),
            React.createElement("span", { role: "listitem" },
                React.createElement(DynamicThemeProviderWrapper, null,
                    React.createElement(TextLinkDeleteFilters, { icon: "erase", iconPosition: "leading", size: "sm", variant: "standalone", onClick: handleClick, numberOfAdditionalChips: numberOfAdditionalChips, isPlpQuickFilters: isPlpQuickFilters }, deleteFiltersLabel))))));
};
const StyledTagGroup = styled((props) => React.createElement(TagGroup, Object.assign({}, props))) `
  margin-top: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_SM)
    : SYS_SPACE_FIXED_200};
  margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_600)
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG)};
  gap: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_100)
    : dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_MD)};
  align-items: ${(props) => props.isPlpQuickFilters ? dynamicStylingHelper('center', 'flex-start') : 'center'};
  flex-flow: ${(props) => props.isPlpQuickFilters ? dynamicStylingHelper('wrap', 'none') : 'wrap'};
  flex-direction: ${(props) => props.isPlpQuickFilters ? dynamicStylingHelper('row', 'column') : 'row'};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    align-items: center;
    flex-flow: wrap;
    margin-top: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_SM)
    : SYS_SPACE_FIXED_400};
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_500, SYS_SPACE_FIXED_600)
    : SYS_SPACE_FIXED_500};
  }
`;
const FilterChipsFooter = styled.div `
  display: flex;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: ${(props) => (props.isPlpQuickFilters ? '100%' : 'unset')};
    flex-direction: ${(props) => props.isPlpQuickFilters ? dynamicStylingHelper('unset', 'column') : 'unset'};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    flex-direction: ${(props) => props.isPlpQuickFilters ? dynamicStylingHelper('unset', 'row') : 'unset'};
  }
`;
const StyledTag = styled((props) => React.createElement(Tag, Object.assign({}, props))) `
  font-size: ${(props) => props.isPlpQuickFilters ? '12px' : dynamicStylingHelper('16px', '12px')};
  margin-right: ${(props) => !props.isPlpQuickFilters && props.isLastTag ? SYS_SPACE_RELATIVE_XS : 'unset'};
`;
const ChipsWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_100};
  margin-bottom: ${SYS_SPACE_RELATIVE_LG};
`;
const StyledTextLink = styled((props) => React.createElement(TextLink, Object.assign({}, props))) `
  ${dynamicStyling({
    alpha: `
      text-decoration: none;

      @media (min-width: ${SYS_BREAKPOINT_LG}) {
        margin-bottom: ${SYS_SPACE_RELATIVE_LG};
      }
  `,
})};
`;
const TextLinkDeleteFilters = styled((props) => React.createElement(TextLink, Object.assign({}, props))) `
  ${dynamicStyling({
    alpha: `
      text-decoration: none;
  `,
})};

  margin-left: ${(props) => props.numberOfAdditionalChips > 0
    ? props.isPlpQuickFilters
        ? '24px'
        : SYS_SPACE_RELATIVE_MD
    : '0'};
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-left: ${(props) => props.numberOfAdditionalChips > 0
    ? props.isPlpQuickFilters
        ? '0px'
        : SYS_SPACE_RELATIVE_MD
    : '0'};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin-left: ${(props) => props.numberOfAdditionalChips > 0
    ? props.isPlpQuickFilters
        ? '24px'
        : SYS_SPACE_RELATIVE_MD
    : '0'};
  }
`;
